import Vue from "vue";
import VueI18n from "vue-i18n";
import EventBus from "@wand/wgact_lib_event_bus";
import { ingame, getSys, download, isMobile } from "@tencent/pa-cms-utils";
import Aegis from "aegis-web-sdk";
import { IRoleItem } from "@/types";
import vConsole from "vconsole";
import { useThrottleFn, onClickOutside, useScroll } from "@vueuse/core";
import Clipboard from "clipboard";
import {
  getRoleInfo,
  saveRoleInfo,
  RoleInfo,
  getShort,
  getAddress,
  sendAddress,
  getCashEmail,
  sendCashEmail,
  TypeSendAddressReq,
  getMyShareCode,
  bindMyShareCode,
  TypeInviteTaskListItem,
  getMyInviteList,
  wandLottery,
  wandLotteryPresents,
  TypeLotteryPresent,
  wandInit,
  addLotteryNum,
  getInviteList,
} from "@/api/modules/page";
import {
  IsTest,
  getLang,
  AreaId,
  isSea,
  isEu,
  REGION_AREA,
  unixToUTC,
  obfuscateEmail,
  copyToClipboard,
} from "@/utils/tools";
import { getSeverList } from "@/utils/serverList";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { isHtm, game_id, JumpUrl } from "@/utils/const";

import Login, { checkLogin } from "@/utils/login";

import { languageArr } from "./utils/setLanguage";
import $ from "lib/query";
import "./style.css";
// import { nextTick } from 'vue/types/umd';

Vue.use(VueI18n);
Vue.use(EventBus);
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
const AegisIdMap = {
  "29175": "LlYdWfjnVrP4pgG5nw", // taris-人拉人
};
const AegisId = AegisIdMap[game_id];
if (!AegisId) {
  console.error("AegisId not found", game_id);
}
new Aegis({
  id: AegisId, // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: "https://rumt-sg.com",
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
// 首页曝光
reportTlog({
  action: "pull_p_home_page",
  sub_action: "cm_vshow",
});
(window as any).reportTlog = reportTlog;
const DEFAULT_LANG = "en";
// 亚服/欧美 多语言筛选
const SEA_Langs = ["zh", "en", "th", "id"]; // 1）繁中2）英语3）泰语4）印尼语
const EU_AM_Langs = ["de", "en", "fr", "pt", "ru", "es"]; // 1）德语2）英语3）法语4）葡语5）俄语6）西语
// 亚服/欧美最多邀请人数限制
const SEA_INVITE_LIMIT = 200;
const EU_AM_INVITE_LIMIT = 5;

// - SEA：https://tarislandua.onelink.me/ZE21/idywdqdl
// - 欧美：https://tarislandua.onelink.me/ZE21/lggvh5uq
const SEA_DOWNLOAD = "https://tarislandua.onelink.me/ZE21/idywdqdl";
const EU_AM_DOWNLOAD = "https://tarislandua.onelink.me/ZE21/lggvh5uq";
/** 抽奖映射 */
const WandLotteryMap: Record<string, number> = {
  level1: 4, // $100 礼品卡
  level2: 5, // $50 礼品卡
  level3: 6, // S1成长礼包
  level4: 1, // 烈虎之灵（永久）
  level5: 2, // 霜狼之灵（永久）
  level6: 3, // 霜狼之灵（1天体验卡）
};

const CMSLanguage = {
  en: "en",
  th: "th",
  fr: "fr",
  de: "de",
  pt: "pt-all",
  es: "es",
  id: "id",
  ru: "ru",
  zh: "zh",
};
// 语言路径
const allLanguageContext = require.context("./locales", false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName);
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  };
}, {});
// console.log('locales', locales);
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales];
  if (lang === undefined) return;
  return storeLang;
};
export const setLocal = (language?: string | null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);

const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// https://1024tools.com/timestamp utc+8
const startTimestamp = 1729555200; // 2024-10-22 00:00:00
const endTimestap = 1733011199; // 2024-11-30 23:59:59
const endTimestap_eu_am = 1732147200; // 2024-11-21 00:00:00
// TODO test
// const startTimestamp = 1716889016; // 2024-05-28 17:36:56
// const endTimestap= 1722441600; // 2024-08-01 00:00:00

let showTimer: ReturnType<typeof setTimeout>;
let showPopTimer: ReturnType<typeof setTimeout>;
new Vue<any>({
  el: "#app",
  data() {
    return {
      language: urlLangType,
      isNewInstall: false, // 是否新进用户
      isActive: false, // 是否回流用户
      lotteryNum: 0, // 抽奖次数
      finishAllTaskNum: 0, // 完成所有任务的邀请人数

      roleId: 0,
      areaId: 0,
      zoneId: 0,
      serverId: 0,
      roleName: "",
      inviteNum: 0,
      inviteList: [],

      savedRoleId: 0,
      savedAreaId: 0,
      savedZoneId: 0,
      savedRoleName: "",
      isInvited: false, // 是否被邀请过

      loginEmail: "",
      isLogin: false,
      choosed: false,
      serverData: [],
      roleList: [],

      loading: false,

      isHtm,

      showMask: false,

      rewardRecord: [],
      isGameStart: true,
      clipboard: null,
      raffling: false,

      freelancerSubmitting: false,
      lotteryEmailSubmitting: false,
      saveAddress: "",
      saveCashEmail: "",

      region: location.pathname.split("/").includes("sea")
        ? "sea"
        : location.pathname.split("/").includes("eu_am")
        ? "eu_am"
        : "sea", // 当前区域
      code: "",
      inviteCode: "",
      inviteRole: "",
      lotteryPageSize: 10,
      lotteryPageNum: 1,
      saveShareCode: "",
      task_1: 0,
      task_2: 0,
      task_3: 0,
      isTriggerArea: false, // 是否激活过
    };
  },
  computed: {
    selectRoleName() {
      if (!this.isLogin) return "";
      if (!this.roleId) return "";
      // console.log('[computed selectRoleName]', this.roleList, this.roleId);
      const role = this.roleList?.find(
        (role: RoleInfo) => role.role_id === this.roleId
      );
      if (!role) return "";

      return role.role_name;
    },
    bindInfo() {
      // console.log(
      //   '[computed bindInfo]',
      //   this.areaId,
      //   this.serverId,
      //   this.roleId,
      //   this.zoneId
      // );
      return {
        areaId: this.areaId,
        serverId: this.serverId,
        roleId: this.roleId,
        zoneId: this.zoneId,
      };
    },
    areaList() {
      const areas =
        this.serverData?.map((server: IRoleItem) => {
          return {
            t: server.t,
            v: server.v,
          };
        }) || [];
      // console.log('[computed areaList] 大区', areas);
      return areas;
    },
    zoneList() {
      const server = this.serverData.find(
        (server: IRoleItem) => server.v == this.areaId
      );
      const zoneList = server?.server.map((item: IRoleItem) => {
        return {
          label: item.t,
          value: item.v,
        };
      });
      // console.log('[computed zoneList] 服务器', zoneList);
      return zoneList || [];
    },
    serverList() {
      const server = this.serverData.find(
        (server: IRoleItem) => server.v == this.areaId
      );
      if (server) {
        // console.log('[computed serverList] 服务器', server.server || []);
        return server.server || [];
      }
      return [];
    },
  },
  watch: {
    language: {
      handler(val) {
        if (
          (this.region === "sea" && !SEA_Langs.includes(val)) ||
          (this.region === "eu_am" && !EU_AM_Langs.includes(val))
        ) {
          const url = new URL(window.location.href);
          url.searchParams.set("lang_type", "en");
          window.location.href = url.href;
        }
        console.log("语言变化了", val);
        window.setLocal(val);
        const langData = languageArr.find((langInfo) => langInfo.value === val);
        (window as any).setLangHTML(val);
        window.$(".lang-on").text(langData?.label);
        window.$(".lang-value").text(langData?.label);
        // onetrust 语言
        window.$("html").attr("lang", val);
        const OneTrustLangMap = {
          // TODO 换成简体
          zh: "zh-tw",
          en: "en",
          id: "id-id",
          th: "th",
          ru: "ru",
          es: "es",
          fr: "fr",
          pt: "pt",
          de: "de",
        };
        (window as any)?.OneTrust?.changeLanguage(
          OneTrustLangMap[val as keyof typeof OneTrustLangMap] || "en"
        );
        const url = new URL(window.location.href);
        url.searchParams.set("lang_type", val === "zh" ? "zh-tw" : val);
        // console.log('检测到语言变化了', url);
        window.history.pushState(null, "", url.href);

        // if (this.inviteList.length > 0) {
        //   const task_1_completed = this.inviteList.reduce(
        //     (acc: number, cur: TypeInviteTaskListItem) => acc + cur.task_1,
        //     0
        //   );
        //   const task_2_completed = this.inviteList.reduce(
        //     (acc: number, cur: TypeInviteTaskListItem) => acc + cur.task_2,
        //     0
        //   );
        //   const task_3_completed = this.inviteList.reduce(
        //     (acc: number, cur: TypeInviteTaskListItem) => acc + cur.task_3,
        //     0
        //   );
        //   // if (task_1_completed) {
        //   //   window.$('.task_1 .mission-btn').removeClass('gray');
        //   //   window
        //   //     .$('.task_1 .mission-btn')
        //   //     .text(`${task_1_completed} ${this.$t('friends-completed')}`);
        //   // } else {
        //   //   window.$('.task_1').find('.mission-btn').addClass('gray');
        //   //   window
        //   //     .$('.task_1 .mission-btn')
        //   //     .text(`${this.$t('no-friends-completed')}`);
        //   // }
        //   // if (task_2_completed) {
        //   //   window.$('.task_2 .mission-btn').removeClass('gray');
        //   //   window
        //   //     .$('.task_2 .mission-btn')
        //   //     .text(`${task_2_completed} ${this.$t('friends-completed')}`);
        //   // } else {
        //   //   window.$('.task_2').find('.mission-btn').addClass('gray');
        //   //   window
        //   //     .$('.task_2 .mission-btn')
        //   //     .text(`${this.$t('no-friends-completed')}`);
        //   // }
        //   // if (task_3_completed) {
        //   //   window.$('.task_3 .mission-btn').removeClass('gray');
        //   //   window
        //   //     .$('.task_3 .mission-btn')
        //   //     .text(`${task_3_completed} ${this.$t('friends-completed')}`);
        //   // } else {
        //   //   window.$('.task_3').find('.mission-btn').addClass('gray');
        //   //   window
        //   //     .$('.task_3 .mission-btn')
        //   //     .text(`${this.$t('no-friends-completed')}`);
        //   // }
        // } else {
        //   window.$('.mission-btn').addClass('gray');
        //   window.$('.mission-btn').text(`${this.$t('no-friends-completed')}`);
        // }
        /** 切换语言的时候需要设置下文案 */
        if (this.task_1) {
          window.$(".task_1 .mission-btn").removeClass("gray");
          window
            .$(".task_1 .mission-btn")
            .text(`${this.task_1} ${this.$t("friends-completed")}`);
        } else {
          window.$(".task_1").find(".mission-btn").addClass("gray");
          window
            .$(".task_1 .mission-btn")
            .text(`${this.$t("no-friends-completed")}`);
        }
        if (this.task_2) {
          window.$(".task_2 .mission-btn").removeClass("gray");
          window
            .$(".task_2 .mission-btn")
            .text(`${this.task_2} ${this.$t("friends-completed")}`);
        } else {
          window.$(".task_2").find(".mission-btn").addClass("gray");
          window
            .$(".task_2 .mission-btn")
            .text(`${this.$t("no-friends-completed")}`);
        }
        if (this.task_3) {
          window.$(".task_3 .mission-btn").removeClass("gray");
          window
            .$(".task_3 .mission-btn")
            .text(`${this.task_3} ${this.$t("friends-completed")}`);
        } else {
          window.$(".task_3").find(".mission-btn").addClass("gray");
          window
            .$(".task_3 .mission-btn")
            .text(`${this.$t("no-friends-completed")}`);
        }
        if (this.saveShareCode) {
          this.renderShareCode(this.saveShareCode);
        }
      },
      immediate: true,
    },
    region: {
      handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          // console.log('当前区域变化了', val, oldVal);
          this.logout();
        }
        if (val === "sea") {
          window.$(".slogan").removeClass("slogan-ea").addClass("slogan-sea");
          window.$(".bonus").removeClass("hide");
          window.$(".select-list li").each((index: number, item: any) => {
            const val = window.$(item).data("val");
            if (!SEA_Langs.includes(val)) {
              window.$(item).addClass("hide");
            }
          });
          window.$(".invited_limit").text(SEA_INVITE_LIMIT);
        } else {
          window.$(".slogan").removeClass("slogan-sea").addClass("slogan-ea");
          window.$(".bonus").addClass("hide");
          window.$(".select-list li").each((index: number, item: any) => {
            const val = window.$(item).data("val");
            if (!EU_AM_Langs.includes(val)) {
              window.$(item).addClass("hide");
            }
          });
          window.$(".invited_limit").text(EU_AM_INVITE_LIMIT);
        }
      },
      immediate: true,
    },
    finishAllTaskNum: {
      handler(val) {
        window.$(".finish_all_task_num").text(val);
        window.$(".cash_earnings").text(val * 5);
      },
      immediate: true,
    },
    areaId(val) {
      // console.log('areaId 变化了', this.areaList, val, this.areaList);
      const curArea = this.areaList.find((item: any) => item.v === val);

      if (curArea) {
        // console.log('[watch areaId', curArea);
        this.buildServerSelect();
        // window.$('.bindAreaName-placeholder').addClass('hide');
        window.$(".bindAreaName-value").text(curArea?.t);
        window
          .$(".bindAreaName-value")
          .removeClass("hide")
          .siblings()
          .addClass("hide");
      }
    },
    serverId: {
      handler(val) {
        // console.log('serverId 变化了', this.serverList, val);
        const curServer = this.serverList.find((item: any) => item.v === val);
        if (curServer) {
          // window.$('.bindServerName').text(curServer?.t);
          window.$(".bindServerName-value").text(curServer?.t);
          window
            .$(".bindServerName-value")
            .removeClass("hide")
            .siblings()
            .addClass("hide");
          // this.buildRoleSelect();
        }
      },
      immediate: true,
    },
    roleId() {
      // handler(val) {
      //   console.log(
      //     "[角色id变化了]selectRoleName",
      //     this.roleList,
      //     val,
      //     this.savedRoleName
      //   );

      // const curRole = this.roleList.find((item: any) => item.role_id === val);
      // console.log(curRole);
      // if (curRole) {
      //   window.$(".bindRoleName").text(curRole?.role_name);
      // }

      // window.$('.bindRoleName').text(this.selectRoleName);
      const role = this.roleList?.find(
        (role: RoleInfo) => role.role_id === this.roleId
      );
      if (this.roleId) {
        window
          .$(".bindRoleName-value")
          .text((role && role.role_name) || this.selectRoleName);
        window
          .$(".bindRoleName-value")
          .removeClass("hide")
          .siblings()
          .addClass("hide");
      } else {
        window
          .$(".bindRoleName-placeholder")
          .removeClass("hide")
          .siblings()
          .addClass("hide");
      }

      //   // window.$(".bindRoleName").text(this.savedRoleName);
      // },
      // immediate: true,
    },
    bindInfo(val, oldVal) {
      const isFull = val.areaId && val.serverId;
      if (!val || !isFull || !checkLogin()) {
        this.buildRoleSelect([]);
        return;
      }
      if (oldVal.areaId === val.areaId && oldVal.serverId === val.serverId) {
        // console.log('相同');
        return;
      }

      if (this.areaRoleMap.get(`${val.areaId}_${val.serverId}`)) {
        const roles = this.roleList.filter(
          (role: RoleInfo) =>
            role.area_id === val.areaId && role.zone_id === val.serverId
        );
        if (roles.length > 0) {
          this.roleId = roles[0].role_id;
        }
        this.buildRoleSelect(roles);
        return;
      }
      this.loading = true;
      this.buildRoleSelect([]);
      this.roleId = 0;

      // console.log('bindInfo===== [watch]', val.areaId, val.serverId);

      if (this.isTriggerArea) {
        getRoleInfo({
          area_id: val.areaId,
          zone_id: val.serverId,
        })
          .then((res) => {
            // console.log('getRoleInfo', res);
            if (!res || res.code !== 0) return;
            const { data } = res;
            if (!data.role_list) return;
            const { role_list: get_role_info = [] } = data;
            this.areaRoleMap.set(`${val.areaId}_${val.serverId}`, true);
            this.roleList.push(...get_role_info);
            // this.roleList = [...get_role_info];
            // 异步 可能 areaId已改变
            if (val.areaId !== this.areaId || val.serverId !== this.serverId) {
              return;
            }
            if (get_role_info.length) {
              const role = get_role_info.find(
                (role: RoleInfo) => role.role_id === this.savedRoleId
              );
              // console.log('查询角色信息', this.savedRoleId, role);
              this.roleId = role ? role.role_id : get_role_info[0].role_id;

              this.savedRoleName = role
                ? role.role_name
                : get_role_info[0].role_name;
            } else {
              // window.$(".bindRoleName").text(this.savedRoleName);
            }
            this.loading = false;
            this.buildRoleSelect(get_role_info);
            // window.$(".bindRoleName").text(this.savedRoleName);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    showMask: {
      handler(val) {
        const mask = window.$(".livingLoading");
        if (!val) {
          if (!mask.length) return;
          mask.addClass("unshow");
          return;
        }
        if (mask.length) {
          mask.removeClass("unshow");
          return;
        }
        const maskDom = window.$('<div class="livingLoading"></div>');
        maskDom.on("click", this.clcikMask);
        maskDom.appendTo(window.$("body"));
      },
      immediate: true,
    },
    isLogin: {
      handler(val) {
        window.$(".state").addClass("hide");
        if (!val) {
          window.$(".state1").removeClass("hide");
          window.$(".user_name .login_logout").hide();
          this.choosed = false;
          this.loginEmail = "";

          return;
        }
        this.init();

        window.$(".state2").removeClass("hide");
        // if (!isMobile()) {
        //   window.$('.state2 .login_logout').show();
        //   window.$('.state3 .login_logout').show();
        // }
        window.$(".state2 .login_logout").show();
        window.$(".state3 .login_logout").show();

        const info = Login.originInfo();
        // console.log('登录信息', info);
        if (!info) return;
        this.loginEmail =
          info.email ||
          info.user_name ||
          `Player${info.openid?.substring(info.openid.length - 4)}`;
      },
    },
    choosed(val) {
      if (!this.isLogin) return;
      window.$(".state").addClass("hide");
      if (!val) {
        window.$(".state2").removeClass("hide");
        return;
      }
      window.$(".state3").removeClass("hide");
    },
    loginEmail: {
      handler(val) {
        window.$(".state2 .email .login_t").text(val);
        window.$(".state3 .email .login_t").text(val);
        window.$(".user_name span").text(val);
      },
      immediate: true,
    },
    savedRoleName: {
      handler(val) {
        window.$(".state3 .role_n").text(val);
      },
    },
    savedZoneId: {
      async handler(val) {
        // const zones = await this.getZoneList();
        // const zone = zones.find((item: any) => item.v === val);
        // window.$('.state3 .server.login_t').text(zone?.t);
        // window.$('.c3 .form input:nth(0)').val(zone?.t || '');
      },
    },
    lotteryNum: {
      handler(val) {
        console.log("抽奖次数变化了", val, Number(val) === 0);
        window.$("#lotteryNum").text(val);
        if (Number(val) === 0) {
          window.$(".lottery-btn").addClass("gray");
        } else {
          window.$(".lottery-btn").removeClass("gray");
        }
      },
      immediate: true,
    },

    currenPeriodParams(val) {
      console.log("currenPeriodParams", val);
    },
    prePeriodParams(val) {
      console.log("prePeriodParams", val);
    },

    saveRoleName() {},
    rewardRecord: {
      handler(val) {
        if (val.length > 0) {
          window.$(".c3 .btn_login").show();
        } else {
          const langData = (window as any).GLanguage[
            this.language.toUpperCase()
          ];
          window.$(".c3 .table-container").removeClass("on");
          window.$(".c3 .btn_login").hide();
          window.$(".c3 .table_tips").text(langData.key103).show();
        }
      },
    },
    serverData(val) {
      // handler(val) {
      // console.log('[watch] serverData', val);
      const areas =
        val?.map((server: IRoleItem) => {
          return {
            label: server.t,
            value: server.v,
          };
        }) || [];
      // console.log('大区', areas);
      this.areaList = areas;
      this.buildAreaSelect();

      window.$(".triggerBindAreaName, .bindAreaName").on("click", () => {
        window.$(".bindAreaList").toggleClass("on");
      });
      window.$(".triggerBindServerName, .bindServerName").on("click", () => {
        window.$(".bindServerList").toggleClass("on");
      });
      window.$(".triggerBindRoleName, .bindRoleName").on("click", () => {
        window.$(".bindRoleList").toggleClass("on");
      });
      onClickOutside(
        window.$(".bindAreaList"),
        (event) => {
          if (window.$(".bindAreaList").hasClass("on")) {
            window.$(".bindAreaList").removeClass("on");
          }
        },
        {
          ignore: [".bindAreaName", ".triggerBindAreaName"],
        }
      );
      onClickOutside(
        window.$(".bindServerList"),
        (event) => {
          if (window.$(".bindServerList").hasClass("on")) {
            window.$(".bindServerList").removeClass("on");
          }
        },
        {
          ignore: [".bindServerName", ".triggerBindServerName"],
        }
      );
      onClickOutside(
        window.$(".bindRoleList"),
        (event) => {
          if (window.$(".bindRoleList").hasClass("on")) {
            window.$(".bindRoleList").removeClass("on");
          }
        },
        {
          ignore: [".bindRoleName", ".triggerBindRoleName"],
        }
      );
    },
    areaList: {
      handler(val) {
        // console.log('[watch] areaList', val);
      },
      immediate: true,
    },

    roleList: {
      handler(val) {
        // console.log('[watch] roleList', val);
      },
      immediate: true,
    },
    inviteNum: {
      handler(val) {
        window.$(".invited_num").text(val);
      },
      immediate: true,
    },

    saveShareCode: {
      handler(val) {
        this.renderShareCode(val);
        // const host =
        //   location.host !== 'localhost'
        //     ? location.host
        //     : 'test.tarisglobal.com';
        // const link =
        //   this.region === 'sea'
        //     ? `https://${host}/wand/act/invite/sea/`
        //     : `https://${host}/wand/act/invite/eu_am/`;
        // const msg = `${this.$t('copy_clipboard-text1')}${link}?lang_type=${
        //   this.language === 'zh' ? 'zh-tw' : this.language
        // }&code=${val}&role=${encodeURIComponent(this.savedRoleName)} ${this.$t(
        //   'copy_clipboard-text2'
        // )} ${val}`;
        // // data-clipboard-text
        // window.$('#getMyInvitationLink').attr('data-clipboard-text', msg);
      },
      immediate: true,
    },
  },
  async created() {
    (window as any).checkLogin = this.checkLogin;
    (window as any).showTips = this.showtTips;
    (window as any).showToast = this.showToast;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    if (code) {
      this.inviteCode = code;
    }
    const role = params.get("role");
    if (role) {
      this.inviteRole = role;
    }

    this.areaRoleMap = new Map();
    await this.doGetServerListData();
    await Login.init();
    await initServetime();

    this.addMask();
    if (isSea) {
      this.region = "sea";
    }
    if (isEu) {
      this.region = "eu_am";
    }
  },
  async mounted() {
    this.isLogin = checkLogin();
    this.$WG_ACT_BUS.$on("login", (res: any) => {
      // console.log('=====WG_ACT_BUS=====', res);
      if (res && (res.ret as any) === 0) {
        this.isLogin = true;
      }
    });
    window.$(".btn_windows").on("click", this.downloadPc);

    this.addLanguage();
    this.addLogin();

    // 上报注册
    if (this.isLogin) {
    }

    this.initGetMyInvitationLink();
    this.initGetMyInviteList();
    // this.doWandInit();
    this.initBindInviteCode();
    this.initHtmlAction();
    // if (this.inviteCode && !this.isLogin) {
    //   (window as any).openDialog("J_pop_program");
    // }
    useScroll(document, {
      throttle: 1000,
      onScroll: () => {
        // console.log('scroll');
        window.$(".nav-switch.switch-wrapper").removeClass("show");
        window.$(".fot-switch.switch-wrapper").removeClass("show");
      },
    });
  },
  methods: {
    showtTips(val: string) {
      window.$("#pop2 .pop_tips").text(val);
      (window as any).openDialog("pop2");
    },
    showToast(val: string, duration = 3000) {
      // (window as any).showToast({ msg: val });
      const p = window.$("#J_toast");
      p.find(".msg-wrap").text(val);
      p.addClass("show");
      showTimer = setTimeout(() => {
        p.removeClass("show");
      }, duration);
    },
    async doGetServerListData() {
      if (this.serverData) {
        const serverList = await getSeverList();
        // console.log('获取区服json数据', serverList);
        // 需要根据当前区域过滤（亚服、美服）

        this.serverData = serverList.filter((item) =>
          REGION_AREA.includes(item.t)
        );
      }
    },
    async getZoneList() {
      if (this.serverList) {
        const serverList = await getSeverList();
        this.serverList = serverList;
      }
      const zones =
        this.serverList.find((item: any) => item.v === AreaId)?.server || [];
      return zones;
    },
    async init() {
      this.getLoginedInitInfo();
    },
    async downloadPc() {
      function isMacOS() {
        const userAgent = window.navigator.userAgent;
        return userAgent.indexOf("Mac") !== -1;
      }
      if (isMobile() || isMacOS()) {
        (window as any).openDialog("J_pop_normal", this.$t("download_pc"));
        // this.showToast(this.$t('downloadPc'));
        return;
      } else {
        // window.$('.btn_windows').attr('target', '_blank');
      }
      if (!this.shortCode) {
        const res = await getShort();
        if (!res || res?.result?.error_code !== 0) {
          // TODO 长短码获取失败
          return;
        }
        this.shortCode = res.code;
      }
      const url = JumpUrl.Download;
      const dom = document.createElement("a");
      dom.setAttribute("href", url);
      dom.setAttribute(
        "download",
        `TARISMiniLoader_${this.shortCode}.wg.intl.exe`
      );
      dom.click();
    },
    addLanguage() {
      const clickLang = (event: Event) => {
        const target = window.$(event.target);
        const lang =
          target.attr("data-val") || target.parent().attr("data-val");
        this.language = lang;
      };
      window.$(".lang-select li").on("click", clickLang);
    },
    addLogin() {
      window.$(".login_accout").on("click", this.clickLogin);
      window.$(".login_role").on("click", this.trigerAreaSelect);
      window.$(".login_character").on("click", this.trigerAreaSelect);
      window.$(".login_logout").on("click", this.clickLogout);
      /** 绑定角色按钮 */
      window.$("#J_pop_sel_chara .btn-reward").on(
        "click",
        useThrottleFn(() => {
          this.submitRole();
        }, 2000)
      );

      // 隐藏登录、登出和切换角色

      if (!this.isLogin) {
        window.$(".login_logout").hide();
      }

      if (isMobile()) {
        window.$(".user_name").on("click", this.clickLogin);
      }
    },
    /** 展示 program 弹框 (未登录) */
    showProgramDialog() {
      // 邀请人与被邀请人视角
      if (
        // !localStorage.getItem(`${this.region}_program`) &&
        !this.isLogin &&
        this.inviteCode &&
        this.inviteRole &&
        !localStorage.getItem(
          `${this.region}_program_${this.inviteCode}_${this.inviteRole}`
        )
      ) {
        window.$("#J_pop_program .inviteRole").text(this.inviteRole);
        (window as any).openDialog("J_pop_program");

        window.$("#J_pop_program .login_accout").on("click", () => {
          if (!this.checkLogin() || !this.checkRole()) {
            return;
          }
          (window as any).closeDialog("J_pop_program");
          this.getLoginedInitInfo();
        });

        // localStorage.setItem(`${this.region}_program`, "1");
      }
    },
    // 活动过期蒙层
    addMask() {
      if (this.region === "sea") {
        if (
          window.serverTime < startTimestamp ||
          window.serverTime > endTimestap
        ) {
          this.showMask = true;
        }
        console.log("活动是否过期", this.showMask, this.isLogin);
      } else {
        if (
          window.serverTime < startTimestamp ||
          window.serverTime > endTimestap_eu_am
        ) {
          this.showMask = true;
        }
        console.log("活动是否过期", this.showMask, this.isLogin);
      }

      console.log("活动是否过期", this.showMask, this.isLogin);
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t("act_not_start"));
        return;
      }

      if (this.region === "sea") {
        if (window.serverTime > endTimestap) {
          this.showMessage(this.$t("act_finished"));
          return;
        }
      } else {
        if (window.serverTime > endTimestap_eu_am) {
          this.showMessage(this.$t("act_finished"));
          return;
        }
      }

      this.showMask = false;
    },
    showMessage(text: string) {
      // window.showTips(text);
      (window as any).openDialog("J_pop_normal", text);
    },
    /**  */
    renderShareCode(val: string) {
      const host =
        location.host !== "localhost" ? location.host : "test.tarisglobal.com";
      const link =
        this.region === "sea"
          ? `https://${host}/wand/act/invite/sea/`
          : `https://${host}/wand/act/invite/eu_am/`;
      const msg = `${this.$t("copy_clipboard-text1")} ${link}?lang_type=${
        this.language === "zh" ? "zh-tw" : this.language
      }&code=${val}&role=${encodeURIComponent(this.savedRoleName)} ${this.$t(
        "copy_clipboard-text2"
      )} ${val}`;
      // data-clipboard-text
      window.$("#getMyInvitationLink").attr("data-clipboard-text", msg);
    },
    /** 绑定角色 */
    async submitRole() {
      if (this.loading) return;
      if (!this.checkLogin()) {
        return;
      }
      if (
        !this.roleId ||
        this.roleId === "0" ||
        !this.areaId ||
        this.areaId === "0"
      ) {
        console.log("绑定角色，没有角色信息");
        this.showToast(this.$t("not-found-role"), 2000);
        showPopTimer = setTimeout(() => {
          if (
            window
              .$("#J_pop_download_complete")
              .attr("style")
              ?.indexOf("display: block") !== -1
          ) {
            return;
          }
          (window as any).openDialog("J_pop_download_complete", "", false);
        }, 2000);

        return;
      }
      if (this.roleId === this.savedRoleId) {
        window.closeDialog("J_pop_sel_chara");

        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
          zone_id: this.serverId,
        });
        if (res && res.code == 0) {
          // 切换角色
          this.getLoginedInitInfo();
          window.closeDialog("J_pop_sel_chara");
          // console.log('登录信息', Login.originInfo());
          reportTlog({
            action: "pull_p_bind_account_ret",
            sub_action: "cm_vshow",
            ext_content: {
              ret: res,
              open_id: Login.info()?.openid || "",
              email: Login.originInfo()?.email || "",
            },
          });
        }
      } finally {
        this.loading = false;
      }
      return;
    },
    async trigerAreaSelect() {
      // await this.doGetServerListData();
      // await this.$nextTick()

      const areaDom = this.areaList?.map((role: IRoleItem) => {
        const divDom = window.$(`<li value=${role.v}>${role.t}</li>`);
        divDom.on("click", this.handleAreaSelect);
        return divDom;
      });
      window.$("#bindAreaList").empty().append(areaDom);

      (window as any).openDialog("J_pop_sel_chara");

      if (this.savedAreaId && this.savedServerId) {
        const curArea = this.areaList?.find(
          (item: IRoleItem) => Number(item.v) === Number(this.savedAreaId)
        );
        const curServer = this.serverList?.find(
          (item: IRoleItem) => Number(item.v) === Number(this.savedServerId)
        );

        if (curArea) {
          window
            .$(".bindAreaName-placeholder")
            .addClass("hide")
            .siblings()
            .removeClass("hide");
          window.$(".bindAreaName-value").text(curArea.t);
        }
        if (curServer) {
          window
            .$(".bindServerName-placeholder")
            .addClass("hide")
            .siblings()
            .removeClass("hide");
          window.$(".bindServerName-value").text(curServer.t);
        }
        getRoleInfo({
          area_id: this.savedAreaId,
          zone_id: this.savedServerId,
        })
          .then((res) => {
            // console.log('getRoleInfo', res);
            if (!res || res.code !== 0) return;
            const { data } = res;
            if (!data.role_list) return;
            const { role_list: get_role_info = [] } = data;
            this.areaRoleMap.set(
              `${this.savedAreaId}_${this.savedServerId}`,
              true
            );
            this.roleList.push(...get_role_info);

            if (get_role_info.length) {
              const role = get_role_info.find(
                (role: RoleInfo) => role.role_id === this.savedRoleId
              );
              // console.log('查询角色信息', this.savedRoleId, role);
              this.roleId = role ? role.role_id : get_role_info[0].role_id;

              this.savedRoleName = role
                ? role.role_name
                : get_role_info[0].role_name;
            }
            this.loading = false;
            this.buildRoleSelect(get_role_info);
            // window.$(".bindRoleName").text(this.savedRoleName);
          })
          .finally(() => {
            this.loading = false;
          });
      }
      this.isTriggerArea = true;
    },
    bindAreaSelect() {
      const areaDom = this.areaList?.map((role: IRoleItem) => {
        const divDom = window.$(`<li value=${role.v}>${role.t}</li>`);
        divDom.on("click", this.handleAreaSelect);
        return divDom;
      });
      window.$(".bindAreaList").empty().append(areaDom);
    },
    buildAreaSelect() {
      const areaDom = this.areaList?.map((role: IRoleItem) => {
        const divDom = window.$(`<li value=${role.v}>${role.t}</li>`);
        divDom.on("click", this.handleAreaSelect);
        return divDom;
      });
      window.$(".bindAreaList").empty().append(areaDom);
    },
    handleAreaSelect(event: Event) {
      const value = window.$(event.target).attr("value");
      console.log("handleAreaSelect", value);
      this.areaId = value;
      // window.$('.bindAreaList').toggleClass('on');
      // window.$(".bindAreaName").text(value);
      const curServer = this.serverList.find(
        (item: IRoleItem) => item.v === this.areaId
      );
      if (curServer) {
        const serverDom = curServer.server?.map((role: IRoleItem) => {
          const divDom = window.$(`<li value="${role.v}">${role.t}</li>`);
          divDom.on("click", this.handleServerSelect);
          return divDom;
        });
        window.$(".bindServerList").empty().append(serverDom);
      }
      this.serverId = "";
      this.roleId = "";

      window
        .$(".bindServerName-placeholder")
        .removeClass("hide")
        .siblings()
        .addClass("hide");
      window
        .$(".bindRoleName-placeholder")
        .removeClass("hide")
        .siblings()
        .addClass("hide");
    },
    buildServerSelect() {
      // const zones =
      //   this.serverList.find((item: any) => item.v === this.areaId)?.server ||
      //   [];
      const serverDoms = this.serverList?.map((zone: any) => {
        const divDom = window.$(`<li value="${zone.v}">${zone.t}</li>`);
        divDom.on("click", this.handleServerSelect);
        return divDom;
      });
      window.$(".bindServerList").empty().append(serverDoms);
    },
    handleServerSelect(event: Event) {
      const value = window.$(event.target).attr("value");
      this.serverId = value;
      // window.$('.bindServerList').toggleClass('on');

      console.log("handleServerSelect", value);

      this.roleId = "";
      window
        .$(".bindRoleName-placeholder")
        .removeClass("hide")
        .siblings()
        .addClass("hide");
      return;
    },

    buildRoleSelect(roleList: RoleInfo[]) {
      // console.log('buildRoleSelect', roleList);
      if (!(this.areaId && this.serverId)) return;
      let options = [];
      if (this.loading) {
        const divDom = window.$(
          `<li value="0" disabled data-lang="loading">${this.$t(
            "loadding"
          )}</li>`
        );
        divDom.on("click", this.handleRoleSelect);
        options = [divDom];
      } else {
        options = roleList?.map((role: RoleInfo) => {
          const divDom = window.$(
            `<li value=${role.role_id}>${role.role_name}</li>`
          );
          divDom.on("click", this.handleRoleSelect);
          return divDom;
        });
      }

      if (options.length === 0) {
        const divDom = window.$(
          `<li value="0" disabled data-lang="NoRoleInfo">${this.$t(
            "not-found-role"
          )}</li>`
        );
        divDom.on("click", this.handleRoleSelect);
        options = [divDom];
      }
      window.$(".bindRoleName-value").text(this.$t("not-found-role"));
      window.$("#bindRoleList").empty().append(options);
    },
    handleRoleSelect(event: Event) {
      const value = window.$(event.target).attr("value");
      console.log("选择了角色", value);
      // window.$('.bindRoleList').toggleClass('on');
      if (value && Number(value) > 0) {
        this.roleId = value;
        const role = this.roleList?.find(
          (role: RoleInfo) => role.role_id === this.roleId
        );
        window
          .$(".bindRoleName-value")
          .text((role && role.role_name) || this.selectRoleName);
      }
    },
    async clickLogin(ev: any) {
      reportTlog({
        action: "invite_page_login_btn",
        sub_action: "cm_click",
      });
      if (!this.isLogin) {
        this.checkLogin();
        return;
      }
      ev.stopPropagation();
    },
    logout() {
      Login.logout();
      this.isLogin = false;
      // 清理信息
      this.savedAreaId = 0;
      this.savedRoleId = 0;
      this.savedZoneId = 0;
      this.savedServerId = 0;
      this.savedRoleName = "";
      this.areaId = 0;
      this.serverId = 0;
      this.roleId = 0;
      this.zoneId = 0;
      this.serverList = [];
      this.roleList = [];
      this.saveCashEmail = "";
      this.saveAddress = "";
      this.saveShareCode = "";

      console.log("logout", this);
      window.location.reload();
    },
    checkLogin(direct = true) {
      if (!this.isLogin) {
        if (direct) {
          // 打开登录框
          Login.login(this.language).then(async (res) => {
            if (res && (res.ret as any) === 0) {
              this.isLogin = true;
              // this.getLoginedInitInfo();
            }
          });
          return false;
        } else {
          (window as any).openDialog("J_pop_login_before");
          window.$("#J_pop_login_before .login_accout").on("click", () => {
            (window as any).closeDialog("J_pop_login_before");
          });

          return false;
        }
      }
      return this.isLogin;
    },
    checkRole(direct = true) {
      if (!this.checkLogin(false)) return;
      if (!this.choosed) {
        if (direct) {
          this.trigerAreaSelect();
          return false;
        } else {
          (window as any).openDialog("J_pop_bind_before");
          return false;
        }
      }
      // console.log(
      //   'checkRole',
      //   this.choosed,
      //   this.savedAreaId,
      //   this.saveRoleName
      // );
      return this.choosed;
    },
    checkGameStart() {
      if (this.isGameStart) return true;
      this.showMessage(this.$t("act_not_start"));
      return false;
    },
    async getLoginedInitInfo() {
      if (!this.isLogin) return;
      try {
        this.loading = true;
        window.$(".loading").show();
        await this.getLoginedInfo();
      } finally {
        this.loading = false;
        window.$(".loading").hide();
      }
    },
    clickLogout(event: Event) {
      event.stopPropagation();
      window.$(".loginout_box").show();
      this.logout();
    },

    async getLoginedInfo() {
      const res = await wandInit();
      // console.log('getLoginedInfo 初始化', res);
      if (!res || res.code !== 0) return;
      const { data } = res;
      const {
        get_saved_role_info,
        has_saved_role_info,
        lottery_num,
        finish_all_task_num,
        is_newinstall_or_active,
        invited_people_num,
        is_invited,
      } = data;

      this.lotteryNum = lottery_num;
      this.finishAllTaskNum = Number(finish_all_task_num?.num) || 0;
      this.inviteNum = Number(invited_people_num?.num) || 0;
      this.isActive = is_newinstall_or_active?.isActive;
      this.isNewInstall = is_newinstall_or_active?.isNewInstall;
      this.choosed = !!has_saved_role_info;
      this.isInvited = is_invited;
      if (is_invited) {
        window.$(".side-code-wrap").addClass("hide");
        window.$(".code-bound").removeClass("hide");
      } else {
        window.$(".side-code-wrap").removeClass("hide");
        window.$(".code-bound").addClass("hide");
      }
      if (get_saved_role_info) {
        const { area_id, role_id, zone_id, role_name } =
          get_saved_role_info || {};
        this.savedAreaId = area_id;
        this.areaId = area_id;
        this.savedZoneId = zone_id;
        this.serverId = zone_id;
        this.savedServerId = zone_id;
        this.savedRoleId = role_id;
        this.roleId = role_id;
        this.savedRoleName = role_name;
      } else {
        this.savedAreaId = 0;
        this.savedRoleId = 0;
        this.savedZoneId = 0;
        this.savedServerId = 0;
        this.savedRoleName = "";
      }

      // const rs = await getAddress({
      //   name: get_saved_role_info?.role_name,
      // });
      // console.log('获取已经填写的地址', rs);
      // if (rs?.code === 0 && rs?.data) {
      //   this.saveAddress = obfuscateEmail(rs.data.address_info?.email);
      //   console.log('获取已经填写的地址', this.saveAddress);
      // } else {
      //   this.saveAddress = '';
      // }

      // if (this.region === 'sea') {
      //   const rsCashEmail = await getCashEmail({
      //     name: get_saved_role_info?.role_name,
      //   });
      //   console.log('获取填写的奖金邮箱', rsCashEmail);
      //   if (rsCashEmail?.code === 0 && rsCashEmail?.data) {
      //     this.saveCashEmail = obfuscateEmail(
      //       rsCashEmail.data.address_info?.email
      //     );
      //   } else {
      //     this.saveCashEmail = '';
      //   }
      // }

      // 执行绑定操作
      if (
        this.inviteCode &&
        this.inviteRole &&
        !localStorage.getItem(
          `${this.region}_program_${this.inviteCode}_${this.inviteRole}`
        )
      ) {
        const rs = await this.doBindInviteCode({ share_code: this.inviteCode });
        // if (rs) {
        //   localStorage.setItem(
        //     `${this.region}_program_${this.inviteCode}_${this.inviteRole}`,
        //     '1'
        //   );
        // }
      }
      /** 获取邀请人列表 */
      // const rsInviteList = await getMyInviteList();
      // if (rsInviteList.code === 0 && rsInviteList.data) {
      //   this.inviteList =
      //     rsInviteList.data?.invite_people_list?.people_list || [];
      // }
      /** 已登录/已绑定角色，提前获取邀请码 */
      if (this.isLogin && this.choosed) {
        this.handleMyInvitationLink(false);
        const rs = await getInviteList();
        // console.log('邀请人任务列表', rs);
        if (rs.code === 0 && rs.data) {
          const { task_1, task_2, task_3 } = rs.data?.invite_people_list;
          this.task_1 = task_1 || 0;
          this.task_2 = task_2 || 0;
          this.task_3 = task_3 || 0;

          if (task_1) {
            window.$(".task_1 .mission-btn").removeClass("gray");
            window
              .$(".task_1 .mission-btn")
              .text(`${task_1} ${this.$t("friends-completed")}`);
          } else {
            window.$(".task_1").find(".mission-btn").addClass("gray");
            window
              .$(".task_1 .mission-btn")
              .text(`${this.$t("no-friends-completed")}`);
          }
          if (task_2) {
            window.$(".task_2 .mission-btn").removeClass("gray");
            window
              .$(".task_2 .mission-btn")
              .text(`${task_2} ${this.$t("friends-completed")}`);
          } else {
            window.$(".task_2").find(".mission-btn").addClass("gray");
            window
              .$(".task_2 .mission-btn")
              .text(`${this.$t("no-friends-completed")}`);
          }
          if (task_3) {
            window.$(".task_3 .mission-btn").removeClass("gray");
            window
              .$(".task_3 .mission-btn")
              .text(`${task_3} ${this.$t("friends-completed")}`);
          } else {
            window.$(".task_3").find(".mission-btn").addClass("gray");
            window
              .$(".task_3 .mission-btn")
              .text(`${this.$t("no-friends-completed")}`);
          }
        }
      }
    },
    /** 这个可能有低版本兼容性 */
    setClipboard(text: string) {
      return new Promise((resolve) => {
        const type = "text/plain";
        const host =
          location.host !== "localhost"
            ? location.host
            : "test.tarisglobal.com";
        const link =
          this.region === "sea"
            ? `https://${host}/wand/act/invite/sea/`
            : `https://${host}/wand/act/invite/eu_am/`;
        const msg = `${this.$t("copy_clipboard-text1")}${link}?lang_type=${
          this.language === "zh" ? "zh-tw" : this.language
        }&code=${text}&role=${encodeURIComponent(this.savedRoleName)} ${this.$t(
          "copy_clipboard-text2"
        )} ${text}`;
        // data-clipboard-text
        window.$(".J_pop_copy_success_close").attr("data-clipboard-text", msg);
        // console.log(this.clipboard);
        resolve(true);
      });
    },
    /** 我的邀请码 */
    async handleMyInvitationLink(direct = true) {
      if (!this.checkLogin(false) || !this.checkRole(false)) return;
      if (!this.saveShareCode) {
        // console.log('登录信息', Login.originInfo());
        const rs = await getMyShareCode();
        // console.log(rs);
        if (rs?.code === 0 && rs?.data) {
          const { share_code } = rs.data;
          this.saveShareCode = share_code;
          // window
          //   .$('#getMyInvitationLink')
          //   .attr('data-clipboard-text', share_code);

          // const isCopyed = await this.setClipboard(share_code);
          // console.log('复制结果', isCopyed);
          // if (isCopyed && direct) {
          //   if (isSea) {
          //     (window as any).openDialog('J_pop_copy_success_sea');

          //     // (window as any).openDialog(
          //     //   'J_pop_normal',
          //     //   this.$t('invite_link_copied_sea')
          //     // );
          //   } else {
          //     (window as any).openDialog('J_pop_copy_success_ea');
          //     // (window as any).openDialog(
          //     //   'J_pop_normal',
          //     //   this.$t('invite_link_copied_eu_am')
          //     // );
          //   }
          // }
        }
      }
    },
    /** 绑定邀请码 */
    async doBindInviteCode(params: { share_code: string }) {
      if (!this.checkLogin(false) || !this.checkRole(false)) return false;
      // if (!(this.isActive || this.isNewInstall) && this.inviteNum === 0) {
      //   console.log('没有资格，不是新进也不是回流');
      //   (window as any).openDialog('J_pop_bound_fail');
      //   return false;
      // }
      const rs = await bindMyShareCode(params);
      // console.log('绑定邀请码返回', rs);
      if (rs?.code === 0 && rs?.data) {
        if (
          !rs.data?.is_newinstall_or_active.isActive &&
          !rs.data?.is_newinstall_or_active.isNewInstall
        ) {
          console.log("绑定邀请码---没有资格，不是新进也不是回流");
          (window as any).openDialog("J_pop_bound_fail");
          localStorage.setItem(
            `${this.region}_program_${this.inviteCode}_${this.inviteRole}`,
            "1"
          );
          return false;
        } else {
          // 看填写邀请码的时候是否能够返回这个邀请码主人的角色名
          const roleName = this.inviteRole || rs.data?.role_info?.role_name;
          if (roleName) {
            window.$("#J_pop_bound_success .inviteRole").text(roleName);
          }
          (window as any).openDialog("J_pop_bound_success");
          localStorage.setItem(
            `${this.region}_program_${this.inviteCode}_${this.inviteRole}`,
            "1"
          );
          return true;
        }
      } else {
        switch (rs?.code) {
          case 501007:
            // 用户已被邀请过
            (window as any).openDialog("J_pop_bound_already");
            break;
          case 501004:
            // 无法分享给自己
            (window as any).openDialog(
              "J_pop_normal",
              this.$t("cant-invite-self")
            );
            break;
          case 501001:
            // 邀请码错误
            (window as any).openDialog(
              "J_pop_normal",
              this.$t("invite_link_disabled")
            );
            break;
          case 501008:
            // 邀请人数达到上限
            (window as any).openDialog(
              "J_pop_normal",
              this.$t("invite_link_upper_limit")
            );
            break;
          default:
            console.log("绑定邀请码异常", rs);
            (window as any).openDialog("J_pop_normal", this.$t("system-error"));
            break;
        }
        localStorage.setItem(
          `${this.region}_program_${this.inviteCode}_${this.inviteRole}`,
          "1"
        );
        return false;
      }
    },

    initBindInviteCode() {
      window.$("#bindInviteCodeBtn").click(() => {
        if (!this.checkLogin(false) || !this.checkRole(false)) return;
        const share_code = String(window.$("#bindInviteCodeInput").val());
        // console.log(
        //   '填写邀请码',
        //   this.isActive,
        //   this.isNewInstall,
        //   !(this.isActive || this.isNewInstall)
        // );
        if (!share_code) {
          // 请输入邀请码
          (window as any).openDialog(
            "J_pop_normal",
            this.$t("enter_your_invitation_code")
          );
        } else {
          // tsecstr仅允许中英文字母、数字、=、+、/、@、#、_、-传入。注意，字符集不包括空格、|等符号
          if (/^[\u4e00-\u9fa5a-zA-Z0-9=+\/*#@_-]{3,}$/.test(share_code)) {
            this.doBindInviteCode({ share_code });
          } else {
            // 邀请码前端验证不通过
            (window as any).openDialog(
              "J_pop_normal",
              this.$t("invite_link_disabled")
            );
          }
        }
      });
    },

    initGetMyInvitationLink() {
      window.$("#getMyInvitationLink").on(
        "click",
        useThrottleFn(() => {
          this.handleMyInvitationLink();
        }, 500)
      );
      this.clipboard = new Clipboard("#getMyInvitationLink");

      this.clipboard.on("success", (e: any) => {
        if (this.isLogin && this.choosed) {
          // console.log('clipboard success', e);
          if (isSea) {
            (window as any).openDialog("J_pop_copy_success_sea");
          } else {
            (window as any).openDialog("J_pop_copy_success_ea");
          }
        }
      });
      this.clipboard.on("error", () => {
        console.log("clipboard error");
        // resolve(false);
      });
    },

    /** 我的邀请人任务列表 */
    async doGetMyInviteList() {
      if (!this.checkLogin(false) || !this.checkRole(false)) return;

      const rs = await getMyInviteList();
      // console.log('邀请人列表', rs);
      if (rs?.code === 0 && rs?.data) {
        this.inviteList = rs.data?.invite_people_list?.people_list || [];
        if (
          rs.data?.invite_people_list !== undefined &&
          rs.data.invite_people_list?.people_list.length > 0
        ) {
          const list = [...rs.data.invite_people_list.people_list];
          const inviteListDoms = list?.map((task: TypeInviteTaskListItem) => {
            return window.$(
              `<tr><td class="col-1">${
                task.invitation_role_name
              }</td><td><span class="${
                task.task_1 === 1 ? "completed" : "unfinished"
              }">${
                task.task_1 === 1
                  ? this.$t("pop_invitedlist_s")
                  : this.$t("pop_invitedlist_f")
              }</span></td><td><span class="${
                task.task_2 === 1 ? "completed" : "unfinished"
              }">${
                task.task_2 === 1
                  ? this.$t("pop_invitedlist_s")
                  : this.$t("pop_invitedlist_f")
              }</span></td><td><span class="${
                task.task_3 === 1 ? "completed" : "unfinished"
              }">${
                task.task_3 === 1
                  ? this.$t("pop_invitedlist_s")
                  : this.$t("pop_invitedlist_f")
              }</span></td></tr>`
            );
          });
          // 首行
          const tbodyFirst = document.querySelector(
            "#J_pop_myInviteList tbody tr"
          );
          window
            .$("#J_pop_myInviteList tbody")
            .empty()
            .append(tbodyFirst)
            .append(inviteListDoms);
          (window as any).openDialog("J_pop_myInviteList");
        } else {
          // 没有邀请人列表
          (window as any).openDialog("J_pop_myInviteListEmpty");
        }
      } else {
      }
    },
    initGetMyInviteList() {
      window.$("#getMyInviteList").on(
        "click",
        useThrottleFn(() => {
          // useThrottleFn(, 500);
          this.doGetMyInviteList();
        }, 500)
      );
    },

    /** 初始化 */
    async doWandInit() {
      if (!checkLogin()) {
        // this.showMessage(this.$t("pls_input_info"));
        return;
      }
      const rs = await wandInit();
      if (rs?.code === 0 && rs?.data) {
        this.lotteryNum = rs.data.lottery_num;
        this.finishAllTaskNum = Number(rs.data?.finish_all_task_num?.num) || 0;
        this.isActive = rs.data?.is_newinstall_or_active?.isActive;
        this.isNewInstall = rs.data.is_newinstall_or_active?.isNewInstall;
        if (rs.data.has_saved_role_info) {
          const { area_id, role_id, zone_id, role_name } =
            rs.data.get_saved_role_info || {};
          this.roleName = role_name;
          // this.savedRoleName = rs.data.get_saved_role_info.role_name;
          this.roleId = role_id;
          this.areaId = area_id;
          // this.zoneId = rs.data.get_saved_role_info.zone_id;
          this.serverId = zone_id;

          this.savedAreaId = area_id;
          this.savedRoleId = role_id;
          this.savedZoneId = zone_id;
          this.savedServerId = zone_id;
          this.savedRoleName = role_name;
        } else {
          this.areaId = "";
          this.serverId = "";
          this.roleName = "";
          this.roleId = "";
          this.savedRoleName = "";
          this.savedAreaId = 0;
          this.savedRoleId = 0;
          this.savedZoneId = 0;
          this.savedServerId = 0;

          window
            .$(".bindAreaName-placeholder")
            .removeClass("hide")
            .siblings()
            .addClass("hide");
          window
            .$(".bindServerName-placeholder")
            .removeClass("hide")
            .siblings()
            .addClass("hide");
          window
            .$(".bindRoleName-placeholder")
            .removeClass("hide")
            .siblings()
            .addClass("hide");
        }
      }

      // console.log('初始化', rs);
    },

    initBounusRules() {
      // 人拉人邀请规则
      window.$(".bonusRules").on(
        "click",
        useThrottleFn(() => {
          if (this.region === "sea") {
            (window as any).openDialog("J_pop_instructions");
            // J_pop_rule
          } else {
            (window as any).openDialog("J_pop_rule_eu");
          }
        }, 200)
      );
      // 抽奖规则
      window.$(".lotteryRules").on(
        "click",
        useThrottleFn(() => {
          if (this.region === "sea") {
            (window as any).openDialog("J_pop_rule");
          } else {
            (window as any).openDialog("J_pop_rule_eu");
          }
        }, 200)
      );
    },
    /** 抽奖 */
    initRaffle() {
      window.$(".lottery-btn").on(
        "click",
        useThrottleFn(() => {
          if (Number(this.lotteryNum) === 0) {
            return;
          }
          if (!this.checkLogin(false) || !this.checkRole(false)) return;
          console.log(
            "抽奖机会",
            this.lotteryNum,
            Number(this.lotteryNum) == 0
            // this.$t('no_lottery_num')
          );
          if (this.raffling) return;
          this.doWandLottery();
        }, 500)
      );
    },
    /** 抽奖光圈 顺时针到第几个，从1开始 */
    raffleRing(index: number) {
      return new Promise((resolve) => {
        this.raffling = true;
        const cells = document.querySelectorAll(".lottery-item");
        const raffleItems = [0, 1, 2, 5, 4, 3];
        let extendItems = raffleItems.slice();
        const otherItems = raffleItems.slice(0, index);
        // 取4-6次
        const times = Math.floor(Math.random() * (6 - 4 + 1)) + 4;
        for (let i = 1; i < times; i++) {
          extendItems = extendItems.concat(raffleItems); // 将原始数组连接到扩展数组的末尾
        }
        extendItems = extendItems.concat(otherItems);
        let currentIndex = 0;
        let spinInterval = 50; // 初始切换时间间隔，单位毫秒
        let intervalIncrease = 100; // 每次增加的时间间隔，单位毫秒

        let spinTimer = setInterval(() => {
          // 移除所有单元格的高亮
          cells.forEach((cell) => cell.classList.remove("cur"));
          // 设置当前单元格为高亮
          cells[extendItems[currentIndex]].classList.add("cur");
          // 逐渐增加切换时间间隔
          spinInterval += intervalIncrease;
          // 如果已用时间超过旋转持续时间，则停止旋转
          if (currentIndex >= extendItems.length - 1) {
            clearInterval(spinTimer);
            // 将光圈停在最终停止位置
            // cells.forEach((cell) => cell.classList.remove("cur"));
            // cells[extendItems[currentIndex]].classList.add("on");
            // console.log(`恭喜！中奖号码是第：${index} 个`);
            this.raffling = false;
            resolve(true);
          }
          // 更新索引
          currentIndex = currentIndex + 1;
        }, spinInterval);
      });
    },

    /** 抽奖 */
    async doWandLottery() {
      const rs = await wandLottery();
      // console.log('执行抽奖，doWandLottery', rs);
      if (rs?.code === 0 && rs?.data) {
        const { present_list = [], present_id } = rs.data?.present || {};

        const curPresent = present_list?.find(
          (item) => item.present_id === present_id
        );
        if (curPresent) {
          const level = Number(curPresent.level);

          reportTlog({
            action: "pull_p_gift_draw_ret",
            sub_action: "cm_click",
            ext_content: {
              ret: rs.code,
              gift_id: present_id,
              gift_name: this.$t(`gift${level}`),
            },
          });
          // 抽奖光圈滚动到哪个位置
          await this.raffleRing(WandLotteryMap[`level${level}`]);

          if (level < 3) {
            // 礼品卡
            window
              .$("#J_pop_register_lottery .gift_card")
              .text(Number(level) === 1 ? "$100" : "$50");
            // .text(this.$t(`gift${level}`));

            (window as any).openDialog("J_pop_register_lottery");
            this.initLotteryEmailSubmit();
          } else {
            window
              .$("#J_pop_normal_gift .giftName")
              .text(this.$t(`gift${level}`));
            (window as any).openDialog("J_pop_normal_gift");
          }
          this.lotteryNum = this.lotteryNum - 1;
        }
        //  else {
        //   console.log("抽奖异常",rs);
        //   (window as any).openDialog(
        //     'J_pop_normal',
        //     `system error ${curPresent}`
        //   );
        // }

        // const index = Math.floor(Math.random() * (6 - 1 + 1)) + 1;
        // this.raffleRing(index);
      } else {
        console.log("抽奖异常", rs);
        (window as any).openDialog("J_pop_normal", this.$t("system-error"));

        reportTlog({
          action: "pull_p_gift_draw_ret",
          sub_action: "cm_click",
          ext_content: {
            ret: rs.code,
            gift_id: "",
            gift_name: "",
          },
        });
      }
    },

    /** 我的抽奖奖励列表 */
    initRaffleDetails() {
      window.$(".raffle-details").on(
        "click",
        useThrottleFn(() => {
          if (!this.checkLogin(false) || !this.checkRole(false)) return;
          this.doWandLotteryPrecents({ page_num: 1 });
        }, 500)
      );

      // window.$(".raffle-add").on(
      //   "click",
      //   useThrottleFn(() => {
      //     if (!this.checkLogin(false) || !this.checkRole(false)) return;
      //     this.doAddWandLotteryNum();
      //   }, 500)
      // );
    },
    async doWandLotteryPrecents({ page_num = 1 }: { page_num: number }) {
      const rs = await wandLotteryPresents({
        page_num,
        page_size: this.lotteryPageSize,
      });
      // console.log('doWandLotteryPrecents', rs);
      if (rs?.code === 0 && rs?.data) {
        const { total_num = 0, present_list = [] } =
          rs.data?.present_has_list || {};
        const presentDoms = present_list?.map((present: TypeLotteryPresent) => {
          if (Number(present.level) > 2) {
          } else {
          }
          return window.$(
            `<tr><td class="col-1">${unixToUTC({
              timestamp: Number(present.send_timestamp),
            })} UTC0</td><td>${this.$t(`gift${present.level}`)}</td></tr>`
          );
          // ${present.present_name_language ? present.present_name_language[this.language] : present.present_name}
        });
        window.$("#J_pop_reward tbody").empty().append(presentDoms);
        if (total_num > 10) {
          const pages = Math.ceil(total_num / this.lotteryPageSize);

          const pagesDom = Array.from({ length: pages }, (_, i) => i + 1).map(
            (index) => {
              let divDom;
              if (index === this.lotteryPageNum) {
                divDom = window.$(
                  `<li class="reward-pagenum on" value="${index}">${index}</li>`
                );
              } else {
                divDom = window.$(
                  `<li class="reward-pagenum" value="${index}">${index}</li>`
                );
              }

              divDom.on("click", this.handlePageNum);
              return divDom;
            }
          );

          window.$("#J_pop_reward .reward-pages").empty().append(pagesDom);
        }
        if (present_list.length <= 0) {
          window.$("#J_pop_reward .table-wrap").addClass("hide");
          window.$("#J_pop_reward .no-data").removeClass("hide");
          window.$("#J_pop_reward .reward-pop-email-register").addClass("hide");
        } else {
          window.$("#J_pop_reward .table-wrap").removeClass("hide");
          window.$("#J_pop_reward .no-data").addClass("hide");
          const hasGiftCardItem = present_list?.find(
            (item: TypeLotteryPresent) => Number(item.level) <= 2
          );
          if (hasGiftCardItem) {
            window
              .$("#J_pop_reward .reward-pop-email-register")
              .removeClass("hide");

            window
              .$("#J_pop_register_lottery .gift_card")
              .text(Number(hasGiftCardItem.level) === 1 ? "$100" : "$50");
            // .text(this.$t(`gift${hasGiftCardItem.level}`));

            window
              .$("#J_pop_reward .lottery-email-register")
              .on("click", () => {
                (window as any).openDialog("J_pop_register_lottery");
                this.initLotteryEmailSubmit();
              });
          } else {
            window
              .$("#J_pop_reward .reward-pop-email-register")
              .addClass("hide");
          }
        }
        (window as any).openDialog("J_pop_reward");
      }
    },
    handlePageNum(event: Event) {
      const value = Number(window.$(event.target).attr("value"));
      // console.log('handlePageNum', value);
      if (value === this.lotteryPageNum) return;
      this.lotteryPageNum = value;
      this.doWandLotteryPrecents({ page_num: this.lotteryPageNum });
    },
    /** 增加抽奖机会，仅测试 */
    async doAddWandLotteryNum() {
      // console.log('doAddWandLotteryNum');
      const rs = await addLotteryNum();
      // console.log('增加抽奖机会', rs);
    },
    async doGetCashEmail() {
      if (this.region === "sea") {
        const rsCashEmail = await getCashEmail({
          name: this.savedRoleName,
        });
        // console.log('获取填写的奖金邮箱', rsCashEmail);
        if (rsCashEmail?.code === 0 && rsCashEmail?.data) {
          this.saveCashEmail = obfuscateEmail(
            rsCashEmail.data.address_info?.email
          );
        } else {
          this.saveCashEmail = "";
        }

        if (this.saveCashEmail) {
          (window as any).openDialog("J_pop_cash");
          window.$(".btn-submit-cash.freelancer_register ").addClass("hide");
          window.$(".freelancer_register_change").removeClass("hide");
          window.$("#J_pop_register .register-mail-tips").removeClass("hide");
          window.$(".freelancer_register_email").text(this.saveCashEmail);
        } else {
          // console.log('角色名称', this.savedRoleName);
          window.$("#J_pop_register .register-mail-tips").addClass("hide");
          (window as any).openDialog("J_pop_register");
        }
      }
    },
    /** 获取奖励 */
    initGetRewards() {
      window.$(".getRewards").on(
        "click",
        useThrottleFn(() => {
          if (!this.checkLogin(false) || !this.checkRole(false)) return;

          // if (this.saveCashEmail) {
          //   (window as any).openDialog('J_pop_cash');
          //   window.$('.btn-submit-cash.freelancer_register ').addClass('hide');
          //   window.$('.freelancer_register_change').removeClass('hide');
          //   window.$('#J_pop_register .register-mail-tips').removeClass('hide');
          //   window.$('.freelancer_register_email').text(this.saveCashEmail);
          // } else {
          //   console.log('角色名称', this.savedRoleName);
          //   window.$('#J_pop_register .register-mail-tips').addClass('hide');
          //   (window as any).openDialog('J_pop_register');
          // }
          this.doGetCashEmail();
        }, 500)
      );
      window.$(".freelancer_instructions").on("click", () => {
        (window as any).openDialog("J_pop_rule_freelancer", "", false);
      });
      window.$(".freelancer_register").on("click", () => {
        (window as any).openDialog("J_pop_register");
      });
    },
    /** cash 邮箱登记 */

    initFreelancerSubmit() {
      window.$(".freelancer_submit").on(
        "click",
        useThrottleFn(() => {
          const data = {
            email: String(window.$(".freelancer_email").val()),
            country: String(window.$(".freelancer_country").text()),
            name: this.savedRoleName,
          };
          // 邮箱非空
          if (!data.email.trim()) {
            this.showToast(this.$t("pls_input_email"));
            return;
          }
          const emailRegex =
            /^([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
          if (!emailRegex.test(data.email)) {
            // 邮箱不正确
            console.log("邮箱格式错误");
            this.showToast(this.$t("email_error"));
            return;
          }
          // 只有亚服有奖金邮箱
          if (this.region === "sea") {
            this.doFreelancerSubmit(data);
          }
        }, 500)
      );
    },
    async doFreelancerSubmit(data: TypeSendAddressReq) {
      if (this.freelancerSubmitting) return;
      this.freelancerSubmitting = true;
      // const rs = await sendAddress(data);
      const rs = await sendCashEmail(data);
      // console.log('doFreelancerSubmit', rs, data);
      if (rs?.code === 0) {
        this.saveCashEmail = obfuscateEmail(data.email || "");
        (window as any).closeDialog("J_pop_register");
      }

      this.freelancerSubmitting = false;
    },
    async doGetLotteryEmail() {
      const rs = await getAddress({
        name: this.savedRoleName,
      });
      // console.log('获取已经填写的地址', rs);
      if (rs?.code === 0 && rs?.data) {
        this.saveAddress = obfuscateEmail(rs.data.address_info?.email);
        console.log("获取已经填写的地址", this.saveAddress);
      } else {
        this.saveAddress = "";
      }

      if (this.saveAddress) {
        window
          .$("#J_pop_register_lottery .register-mail-tips")
          .removeClass("hide");
        window
          .$("#J_pop_register_lottery .lottery_register_email")
          .text(this.saveAddress);
      } else {
        window
          .$("#J_pop_register_lottery .register-mail-tips")
          .addClass("hide");
      }
    },
    /** 抽奖邮箱收集 */
    async initLotteryEmailSubmit() {
      await this.doGetLotteryEmail();
      window.$(".lottery_register_submit").on(
        "click",
        useThrottleFn(() => {
          const data = {
            email: String(window.$(".lottery_email").val()),
            name: this.savedRoleName,
          };
          // 邮箱非空
          if (!data.email.trim()) {
            this.showToast(this.$t("pls_input_email"));
            return;
          }
          const emailRegex =
            /^([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
          if (!emailRegex.test(data.email)) {
            // 邮箱不正确
            console.log("邮箱格式错误");
            this.showToast(this.$t("email_error"));
            return;
          }

          this.doLotteryEmailSubmit(data);
        }, 500)
      );
    },
    async doLotteryEmailSubmit(data: TypeSendAddressReq) {
      if (this.lotteryEmailSubmitting) return;
      this.lotteryEmailSubmitting = true;
      // const rs = await sendAddress(data);
      const rs = await sendAddress(data);
      // console.log('doLotteryEmailSubmit', rs, data);
      if (rs?.code === 0) {
        this.saveAddress = obfuscateEmail(data.email || "");
        (window as any).closeDialog("J_pop_register_lottery");
      }

      this.lotteryEmailSubmitting = false;
    },

    // 上报
    initReport() {
      const reportList = [
        {
          query: ".getRewards",
          event: "click",
          action: "pull_p_get_reward_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: "#getMyInvitationLink",
          event: "click",
          action: "pull_p_invite_code_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: "#getMyInviteList",
          event: "click",
          action: "pull_p_progress_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: ".lottery-btn",
          event: "click",
          action: "pull_p_gift_draw_btn",
          sub_action: "cm_click",
          ext_content: { lotteryNum: this.lotteryNum },
        },
        {
          query: ".btn_windows",
          event: "click",
          action: "pull_p_windows_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: ".device-ad",
          event: "click",
          action: "pull_p_googleplay_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: ".device-ip",
          event: "click",
          action: "pull_p_applestore_btn",
          sub_action: "cm_click",
          ext_content: {},
        },

        {
          query: ".login_role",
          event: "click",
          action: "pull_p_bind_account_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: ".bonusRules",
          event: "click",
          action: "pull_p_rule_detail_btn",
          sub_action: "cm_click",
          ext_content: {},
        },
        {
          query: ".lotteryRules",
          event: "click",
          action: "pull_p_rule_detail_icon",
          sub_action: "cm_click",
          ext_content: {},
        },
      ];
      reportList.forEach((item) => {
        const ele = document.querySelector(item.query);
        if (ele) {
          ele.addEventListener(item.event, () => {
            reportTlog({
              action: item.action,
              sub_action: item.sub_action,
              ext_content: item.ext_content,
            });
          });
        }
      });
    },

    initHtmlAction() {
      this.initBounusRules();
      this.initRaffle();
      this.initGetRewards();
      this.initFreelancerSubmit();
      this.initRaffleDetails();
      this.showProgramDialog();

      this.initReport();
      /** 修改下载地址 */
      if (this.region === "sea") {
        window
          .$(
            ".device-ip, .device-ad, #J_pop_program .step-box2 .btn-login, #J_pop_download_complete .download-btn"
          )
          .attr("href", SEA_DOWNLOAD);
      } else {
        window
          .$(
            ".device-ip, .device-ad, #J_pop_program .step-box2 .btn-login, #J_pop_download_complete .download-btn"
          )
          .attr("href", EU_AM_DOWNLOAD);
      }
    },
  },
  beforeDestroy() {
    showTimer && clearTimeout(showTimer);
    showPopTimer && clearTimeout(showPopTimer);
  },
});
